/**
 * @file CallLayout.jsx
 * @description CallLayout component for displaying and managing call layout.
 * @component CallLayout
 * @exports CallLayout - Main component for displaying and managing call layout.
 */

import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const CallsLayout = ({
  leftPanel,
  tabConfig,
  searchCustomer,
  defaultTab = "",
  title = "",
  callBtn,
  menuActions = [],
}) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderTabContent = () => {
    const current = tabConfig.find((tab) => tab.value === currentTab);
    return current?.component || null;
  };
  console.log("menuActions:", menuActions);
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* Left Panel */}
      <Box
        sx={{
          minWidth: 375,
          maxWidth: 375,
          p: 3,
          borderRadius: 3,
          background: "linear-gradient(135deg, #fefefe 0%, #f9f9fb 100%)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          transition: "all 0.3s ease",
          minHeight: "100vh", // Full height on initial load
          height: "auto", // Auto height as list grows
          "&:hover": {
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.12)",
            transform: "translateY(-2px)",
          },
          display: "flex",
          flexDirection: "column",
        }}
      >
        {leftPanel}
      </Box>

      {/* Right Panel */}
      <Box sx={{ flexGrow: 1, p: 2, position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 10,
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          {searchCustomer}
          {callBtn}
          {menuActions && menuActions.length > 0 && (
            <Box>
              <IconButton onClick={handleMenuClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                {menuActions.map((action, idx) => (
                  <MenuItem
                    sx={{ cursor: "pointer", fontSize: "14px" }}
                    key={idx}
                    onClick={
                      action.component
                        ? undefined
                        : () => {
                            handleMenuClose();
                            action.onClick && action.onClick();
                          }
                    }
                  >
                    {action.component ? action.component : action.label}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
        </Box>

        {tabConfig && tabConfig.length > 0 && (
          <>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              {title && <Typography>{title}</Typography>}
            </Box>
            <Tabs
              value={currentTab}
              onChange={(e, val) => setCurrentTab(val)}
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabConfig.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </Tabs>
            <Box mt={2}>{renderTabContent()}</Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CallsLayout;
